import React from 'react';

import { ACTION } from 'constants/index';

import Button, { buttonType, buttonColor } from 'Components/Button';
import EditApplicationButton from 'Components/EditApplicationButton';

import { BOAT_TYPE_LIST } from '../../../../constants/boatApplication';

export default ({
  applicationStatus,
  boat,
  canEdit,
  canDelete,
  isFinalReview,
  loadInProgress,
  performAction,
  user,
}) => {
  const _getHeaderText = () => {
    return boat.boatType
      ? BOAT_TYPE_LIST.find(type => type.value === boat.boatType).name + ' Application'
      : 'Boat Details';
  };

  const _print = () => {
    window.print();
  };

  if (loadInProgress)
    return (
      <section className='scene__scene-header detailsScene__scene-header'>
        <div
          className='go-back-to-list-header-button'
          onClick={() => {
            user.goToList();
          }}
        >
          Back
        </div>
        <header>{_getHeaderText()}</header>
      </section>
    );

  return (
    <section className={`scene__scene-header detailsScene__scene-header ${isFinalReview ? '_border_bottom_none' : ''}`}>
      <div
        className='go-back-to-list-header-button'
        onClick={() => {
          user.goToList();
        }}
      >
        Back
      </div>
      <header>{_getHeaderText()}</header>
      {!isFinalReview && (
        <React.Fragment>
          {canEdit && <EditApplicationButton onClick={performAction(ACTION.EDIT, boat)} />}
          <div className={`detailsScene__status-label ${applicationStatus.toLowerCase()}`}>
            {applicationStatus.toLowerCase()}
          </div>
        </React.Fragment>
      )}
      {canDelete && (
        <Button
          label='Delete'
          type={buttonType.primary}
          color={buttonColor.planeRed}
          buttonClassName='_height_30 _width_90 _margin_left_30'
          onClick={performAction(ACTION.DELETE, boat)}
        />
      )}
      <Button
        type={buttonType.primary}
        color={buttonColor.gray}
        iconClassName='button__icon_printer'
        buttonClassName='_height_30 _width_40 _margin_left_30'
        onClick={_print}
      />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/Header.jsx